import { Grid } from '@mui/material';
import DashboardUserInfoMeetingsCard from '../DashboardUserInfoMeetingsCard';
import DashboardYKMeetingsCard from '../DashboardYKMeetingsCard';
import DashboardParticipantCard from '../DashboardParticipantCard';
import DashboardAnnouncementsCard from '../DashboardAnnouncementsCard';

function DashboardYkOnlyDesign({ ykCountList, countUserInfo, participantList }) {
    return (
        <>
            {/* <Grid container spacing={1} direction="row" style={{ marginBottom: 3 }}>
                <Grid item xs={12} md={12} lg={9}>
                    <DashboardYKMeetingsCard countList={ykCountList} />
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                    <DashboardUserInfoMeetingsCard countList={countUserInfo} />
                </Grid>
            </Grid>

 */}





            <Grid container spacing={1}>

                <Grid item xs={12} lg={9}>
                    <Grid container >

                        <Grid item xs={12} style={{ marginBottom: 5 }}>

                            <DashboardYKMeetingsCard ykCountList={ykCountList} />

                        </Grid>

                        <Grid item xs={12} md={8} lg={8} >

                            <DashboardParticipantCard mainData={participantList} />

                        </Grid>

                        <Grid item xs={12} md={4} lg={4} >

                            <DashboardUserInfoMeetingsCard countList={countUserInfo} />

                        </Grid>


                    </Grid>
                </Grid>

                {/* Sağ Taraf - Duyurular */}
                <Grid item xs={12} lg={3}>

                    <DashboardAnnouncementsCard />

                </Grid>
            </Grid>




        </>
    );
}

export default DashboardYkOnlyDesign; 